module.exports = __webpack_public_path__ + "static/media/Dave Hora.43d4121c.png";